/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddMoreIcon from "../../../assets/img/add_btn_icon.svg";
import { ADD_NOTIFICATION_AND_CMS_URL } from "../../Shared/constant";
import CustomNotification from "./CustomNotification";
import MarketingCampaigns from "./MarketingCampaigns";
import NetPromoterScore from "./NetPromoterScore";
import { useSelector, useDispatch } from "react-redux";
import { getNotificationCmsTab } from "../../../redux/actions/adminActions";

const index = () => {
    const { NotificationsTabs, selfInfo } = useSelector((state) => state.adminReducers);
    const PermissionsAccess = selfInfo?.user?.permissions_access;
    const Navigate = useNavigate();
    const Dispatch = useDispatch();

    useEffect(() => {
        if(NotificationsTabs === undefined) {
            Dispatch(getNotificationCmsTab("custom-notification"));
        };
    }, [ NotificationsTabs ]);

    // REDIRECT TO CREATE NOTIFICATION AND CMS PAGE
    const CreateNotificationAndCMS = () => { 
        Navigate(`${ADD_NOTIFICATION_AND_CMS_URL}/${NotificationsTabs}`);
    };

    return(<section className="Main_section">
        <div className="MainHeader">
            <ul className="MainHeader_Tab">
                <li className={NotificationsTabs === "custom-notification" ? "active" : ""} onClick={() => Dispatch(getNotificationCmsTab("custom-notification"))}>Custom Notification</li>
                <li className={NotificationsTabs === "Campaign" ? "active" : ""} onClick={() => Dispatch(getNotificationCmsTab("Campaign"))}>Marketing Campaigns</li>
                <li className={NotificationsTabs === "net-promoter-score" ? "active" : ""} onClick={() => Dispatch(getNotificationCmsTab("net-promoter-score"))}>Net Promoter Score</li>
            </ul>

            {(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.DealerApp[6]?.Edit) && (<button 
                className="btn head_cmn_btn" 
                id="create_notification_btn" 
                onClick={() => CreateNotificationAndCMS()}
            >
                <img src={AddMoreIcon} alt="addmore" />
                Create Notification
            </button>)}
        </div>
        {NotificationsTabs === "custom-notification" ? (
            <CustomNotification 
                tab_url={"Custom Notification"} 
                main_url={NotificationsTabs}
            />) 
        : NotificationsTabs === "Campaign" ? (
            <MarketingCampaigns 
                tab_url={"CAMPAIGN"} 
                main_url={NotificationsTabs}
            />) 
        : (<NetPromoterScore 
                tab_url={"NPS"} 
                main_url={NotificationsTabs}
            />)}
    </section>);
};

export default index;